import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Bande d'annonces défilantes au-dessus du site (gérée depuis l'admin, onglet Pub). */
export default function AnnouncementTicker() {
    const [items, setItems] = useState(null);

    useEffect(() => {
        api.get("/announcements").then(({ data }) => setItems(data || [])).catch(() => setItems([]));
    }, []);

    if (items === null) return null;
    const msgs = items.length > 0 ? items : [{
        text: "📣 Un concert, une sortie d'album, une promo à annoncer ? Cet espace est à vous — écrivez-nous à contact@mboazick.com",
        link_url: "mailto:contact@mboazick.com",
    }];
    const totalChars = msgs.reduce((s, a) => s + (a.text || "").length, 0);
    const duration = Math.max(18, Math.min(90, totalChars * 0.45));

    const Content = ({ ariaHidden }) => (
        <div className="flex items-center shrink-0" aria-hidden={ariaHidden || undefined}>
            {msgs.map((a, i) => {
                const inner = (
                    <span className="inline-flex items-center gap-2.5 px-8 text-[13px] md:text-sm font-medium whitespace-nowrap leading-none">
                        <span className="text-[#D4AF37] animate-pulse">✦</span>
                        <span className="text-[#F4F4F4]">
                            {a.text}
                        </span>
                    </span>
                );
                return a.link_url ? (
                    <a key={i} href={a.link_url} target={a.link_url.startsWith("/") ? "_self" : "_blank"} rel="noreferrer" className="hover:opacity-80 transition-opacity">
                        {inner}
                    </a>
                ) : (
                    <span key={i}>{inner}</span>
                );
            })}
        </div>
    );

    return (
        <div className="relative h-10 overflow-hidden bg-[#080808] border-b border-[#D4AF37]/20" data-testid="announcement-ticker">
            <div className="absolute inset-y-0 left-0 w-10 z-10 bg-gradient-to-r from-[#080808] to-transparent pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-10 z-10 bg-gradient-to-l from-[#080808] to-transparent pointer-events-none" />
            <div className="mz-marquee flex items-center h-full" style={{ animationDuration: `${duration}s` }}>
                <Content />
                <Content ariaHidden />
            </div>
        </div>
    );
}
